import {Box, Typography} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import {WithTranslation, withTranslation} from 'react-i18next';

import {expectationsStyles} from 'src/Components/Home/Expectations/expectationsStyles';
import {IAnchorable} from 'src/Routes/Pages/IAnchorable';

const Expectations = (props: IExpectationsProps) => (
	<Box
		justifyContent="center"
		flexDirection="column"
		alignItems="center"
		className={props.classes.root}
		component="section"
		id={props.anchor}
	>
		<span className={props.classes.arrowWrapper}>
			<ArrowDownwardIcon className={props.classes.arrow} />
		</span>
		<Typography variant="h4" className={props.classes.why}>
			{props.t('which-is-why')}
		</Typography>
		<Typography variant="h3" className={props.classes.percent}>
			{props.t('for-101-percent')}
		</Typography>
		<Typography variant="h5" className={props.classes.expectations}>
			{props.t('meet-expectations')}
		</Typography>
	</Box>
);

interface IExpectationsProps extends IAnchorable, WithTranslation, WithStyles {}

export default withStyles(expectationsStyles)(withTranslation('expectations')(Expectations));
